import { useTheme } from '@mui/material';

const LabelGradients = () => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === 'light';

  // Label fade gradient colors.
  const color1 = isLightMode
    ? theme.blox?.colors?.bluegray
    : theme.blox?.colors?.lightgray;
  const color2 = isLightMode ? theme.blox?.colors?.white : theme.blox?.colors?.black;

  return (
    <>
      <defs>
        <linearGradient
          id="legend-text-fade-gradient"
          x1="0"
          y1="0"
          x2="800"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0"
            stopColor={color1}
          />
          <stop
            offset="0.14285714285714285"
            stopColor={color1}
          />
          <stop
            offset="0.1857142857142857"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="0.2857142857142857"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="0.42857142857142855"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="0.5714285714285714"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="0.7142857142857143"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="0.8571428571428571"
            stopColor={color2}
            stopOpacity="0"
          />
          <stop
            offset="1"
            stopColor={color2}
            stopOpacity="0"
          />
        </linearGradient>
      </defs>
    </>
  );
};

export default LabelGradients;
